
export function setUsers(state, users_select){
    state.users_select = users_select
}
export function setReport(state, data){
    state.reportUserDocuments = data
}
export function clearParams(state){
    state.params.voucherType_id = null
    state.params.user_id = null
}



// WEBPACK FOOTER //
// ./src/modules/report-user-document/mutations.js